import { Component, ElementRef, EventEmitter, Output, ViewChild } from '@angular/core';
import { ErrorCode, ERROR_DATA, ModalData } from '../models/error-codes-v2';
import { IModalAlerts } from '@npm-bbta/bbog-dig-dt-webcomponents-lib/dist/types/components/sherpa-ml/bdb-ml-modal/IModalAttributes';
import { CustomLogger } from '@npm-bbta/bbog-sg-frontend-logs-lib';

const logger = new CustomLogger('app-bdb-error-v2-modal', 'red');

@Component({
    selector: 'app-bdb-error-v2-modal',
    templateUrl: './bdb-error-v2-modal.component.html',
})
export class BdbErrorV2ModalComponent {
    modalData?: ModalData;
    @ViewChild('modal') modalRef: ElementRef;
    @Output('accept') accept: EventEmitter<void> = new EventEmitter();

    get modalEl(): HTMLBdbMlModalElement {
        return this.modalRef.nativeElement;
    }

    get modalOptions() {
        const options: IModalAlerts[] = [{ id: '0', value: this.modalData?.btnText }];
        return JSON.stringify(options);
    }

    openErrorModal(errorCode: ErrorCode): void {
        const modalData = ERROR_DATA[errorCode].modalData;

        if (modalData) {
            this.modalData = modalData;
            this.modalEl.openAlert();
        } else {
            logger.error(`Error code ${errorCode} is not supported for modal`);
        }
    }

    handleButtonClick(event: CustomEvent) {
        if (event.detail.id === '0') {
            this.accept.emit();
        } else {
            logger.warn('Event ID not mapped', event.detail);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/bdb-error-v2-modal/bdb-error-v2-modal.component.ts